Vendd.Scripts.load(function () {
    if ($('.back-to-top').length > 0) {
        backToTop();
    }

    if (isTouch()) {
        initFooterMenuToggle();
    }

    if ($('.disclaimer-title.js-disc-toggle').length > 0) {
        disclaimerToggle();
    }    
});

function backToTop() {
    var $backToTop = $(".back-to-top"),
    scroll;

    scroll = $(window).scrollTop();
    scroll > 500 ? $backToTop.addClass("visible") : $backToTop.removeClass("visible");
    $(window).scroll(function () {
        scroll = $(window).scrollTop();
        scroll > 500 ? $backToTop.addClass("visible") : $backToTop.removeClass("visible")
    });

    $backToTop.on("click", function () {
        $("body,html").animate({ scrollTop: 0 }, 400, 'swing');
    });
}

function initFooterMenuToggle() {
    var mainCont = $('.footer-template-one .region-area-two');
    $(".footer-template-one .js-toggle").click(function () {
        var hiddenCont = $(this).siblings('.js-content-accord');
        $(this).toggleClass('icon-arrow-down icon-arrow-up');
        if (hiddenCont.hasClass('opened')) {
            hiddenCont.removeClass('opened');
        } else {
            mainCont.find('.opened').removeClass('opened').siblings('.js-toggle').toggleClass('icon-arrow-down icon-arrow-up');
            hiddenCont.addClass('opened');
        }
    });

    var accordion = false;

    if ($(window).width() <= 767) {
        accordion = true;
    }

    $(window).resize(function () {
        if ($(window).width() > 767) {
            if (accordion) {
                $('.js-content-accord', mainCont).removeClass('opened');
                accordion = false;
            }
        }
        else {
            if (!accordion) {
                $('.js-content-accord', mainCont).siblings('.js-toggle').addClass('icon-arrow-down').removeClass('icon-arrow-up');
                accordion = true;
            }
        }
    });
}

function disclaimerToggle() {
    $(".disclaimer-title.js-disc-toggle").click(function () {
        var hiddenCont = $(this).siblings('.js-disc-content-accord');
        $(this).toggleClass('icon-down-4 icon-up-4');
        if (hiddenCont.hasClass('disc-opened')) {
            hiddenCont.removeClass('disc-opened');
        } else {
            hiddenCont.addClass('disc-opened');
        }
    });
}